import { useObjectUrl } from "@overmap-ai/forms"
import { LngLatBounds } from "mapbox-gl"
import { memo, useId, useMemo } from "react"

import { Layer, Source } from "../components"
import { MapSlotLayerId } from "../enums"

export interface ImageLayerProps {
	file: File
	bounds: LngLatBounds
}

export const ImageLayer = memo((props: ImageLayerProps) => {
	const { file, bounds } = props

	const layerId = useId()

	const objectUrl = useObjectUrl(file)

	const coordinates = useMemo(() => {
		const sw = bounds.getSouthWest()
		const ne = bounds.getNorthEast()

		return [
			[sw.lng, ne.lat],
			[ne.lng, ne.lat],
			[ne.lng, sw.lat],
			[sw.lng, sw.lat],
		] satisfies [[number, number], [number, number], [number, number], [number, number]]
	}, [bounds])

	if (!objectUrl) return

	return (
		<Source type="image" coordinates={coordinates} url={objectUrl}>
			<Layer id={layerId} type="raster" beforeId={MapSlotLayerId.PROJECT_FILES} />
		</Source>
	)
})
ImageLayer.displayName = "ImageLayer"
